import React, { Component } from 'react';
import Item from '../organization/Item';

const CommunityList = (props) => {
    if(props.user.type==="admin") {
      return(
        <div style={{position: 'relative', display: 'flex'}}>
            <Item information={props.information} />
            <div style={{display: 'flex', margin: '0 1em', alignItems: 'center'}}>
              <img
                  src="/images/assets/kryds.svg"
                  alt="Fjern tilknytning"
                  height="26"
                  width="26"
                  style={{cursor: 'pointer'}}
                  onClick={() => { if(window.confirm('Du er ved at fjerne tilknytning mellem trossamfund og menighed. Vær opmærksom på at en menighed uden tilknytning til et trossamfund ikke fremgår på hjemmesiden.')) props.onHandleDissociateComunity()}}
                />
            </div>
        </div>
      )
    } else {
      return (
        <div style={{position: 'relative', display: 'flex'}}>
            <Item information={props.information} hideEditLink={true} />
        </div>
        )
    }
}

export default CommunityList;


// WEBPACK FOOTER //
// ./src/modules/community/List.js